import { getFrotasDisponibilidade } from "@spark/services/frotas";
import { useState, useEffect, useCallback, useRef } from 'react';
import { useAuth } from '../../../../context/AuthContext';

const STATUS_PATIO_LABEL = {
  1: 'Disponiveis',
  2: 'Indisponivel',
  3: 'Em Rota',
  4: 'Problemas Identificados',
  5: 'Manutencao'
};

const STATUS_PATIO_BADGE = {
  1: 'success',
  2: 'danger',
  3: 'danger',
  4: 'danger',
  5: 'danger'
};

export const useDisponibilidadeListagem = () => {
  const { isAuthenticated } = useAuth();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterLoading, setFilterLoading] = useState(false);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [quantidadePorPagina, setQuantidadePorPagina] = useState(5);
  const isMountedRef = useRef(true);
  const [filtros, setFiltros] = useState({
    LocalCidade: '',
    LocalEstado: '',
    Frota: '',
    Veiculo: '',
    NomeMotorista: '',
    NomeGestor: '',
    NomeComercial: '',
    Destino: '',
    Vazio: '',
    Coleta: 'false',
    Negociacao: '',
    DescargaPendente: ''
  });

  useEffect(() => {
    isMountedRef.current = true;

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const fetchData = useCallback(async () => {
    if (!isMountedRef.current) return;
    if (!isAuthenticated) {
      if (isMountedRef.current) {
        setLoading(false);
        setFilterLoading(false);
        setData([]);
        setTotalRegistros(0);
      }
      return;
    }

    try {
      setLoading(true);
      const payload = {
        quantidadePorPagina,
        pagina: paginaAtual,
        LocalCidade: filtros.LocalCidade || undefined,
        LocalEstado: filtros.LocalEstado || undefined,
        Frota: filtros.Frota || undefined,
        Veiculo: filtros.Veiculo || undefined,
        NomeMotorista: filtros.NomeMotorista || undefined,
        NomeGestor: filtros.NomeGestor || undefined,
        NomeComercial: filtros.NomeComercial || undefined,
        Destino: filtros.Destino || undefined,
        Vazio: filtros.Vazio === '' ? undefined : filtros.Vazio === 'true',
        Coleta: filtros.Coleta === '' ? undefined : filtros.Coleta === 'true',
        Negociacao: filtros.Negociacao === '' ? undefined : filtros.Negociacao === 'true',
        DescargaPendente: filtros.DescargaPendente === '' ? undefined : filtros.DescargaPendente === 'true'
      };

      const responseData = await getFrotasDisponibilidade(payload);
      if (!isMountedRef.current) return;

      const dadosProcessados = (responseData.registros || []).map((item) => {
        const statusCode = Number(item.StatusPatio);
        return {
          id: item.Id,
          data: item.DataDisponibilidade ? new Date(item.DataDisponibilidade).toLocaleDateString('pt-BR') : '',
          vazioem: item.LocalCidade,
          estado: item.LocalEstado,
          frota: item.Frota,
          veiculo: item.Veiculo || item.Placa || '',
          tipoModelo: item.TipoModelo || '',
          motorista: item.NomeMotorista || '',
          gestor: item.NomeGestor,
          descargaPendente: item.DescargaPendente ? 'Sim' : 'Nao',
          vazio: item.Vazio ? 'Sim' : 'Nao',
          negociacao: item.Negociacao ? 'Sim' : 'Nao',
          coleta: item.Coleta ? 'Sim' : 'Nao',
          comercial: item.NomeComercial || '',
          destino: item.Destino || '',
          statusPatioLabel: STATUS_PATIO_LABEL[statusCode] || 'Nao informado',
          statusPatioVariant: STATUS_PATIO_BADGE[statusCode] || 'secondary',
          disparados: (() => {
            if (!item.DataDisponibilidade) return 0;
            const hoje = new Date();
            const dataDispon = new Date(item.DataDisponibilidade);
            const diffTime = Math.abs(hoje - dataDispon);
            return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          })(),
          diasAguardandoDescarga: item.DiasAguardandoDescarga || 0,
          dataAgendamento: item.DataAgendamento ? new Date(item.DataAgendamento).toLocaleDateString('pt-BR') : ''
        };
      });

      setData(dadosProcessados);
      setTotalRegistros(responseData.totalRegistros || dadosProcessados.length);
    } catch (error) {
      if (!isMountedRef.current) return;
      if (error?.response?.status !== 401) {
        console.error('Erro ao buscar disponibilidade:', error);
      }
      setData([]);
      setTotalRegistros(0);
    } finally {
      if (isMountedRef.current) {
        setLoading(false);
        setFilterLoading(false);
      }
    }
  }, [filtros, paginaAtual, quantidadePorPagina, isAuthenticated]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleFilterApply = useCallback((newFilters) => {
    setFiltros(newFilters);
    setPaginaAtual(1);
    setFilterLoading(true);
  }, []);

  return {
    data,
    loading,
    filterLoading,
    totalRegistros,
    paginaAtual,
    quantidadePorPagina,
    setPaginaAtual,
    setQuantidadePorPagina,
    filtros,
    handleFilterApply
  };
};
